module.exports = __webpack_public_path__ + "img/hub-accounting-logo.f3d26301.webp";